<template>
  <div class="dxy-view">
    <iframe id="dxyIframe" :src="dxyUrl" frameborder="0"></iframe>
  </div>
</template>

<script>
import IframeMessenger from '../../utils/iframePostMessage'
import withRouteTracking from '../../utils/withRouteTracking'
import { getShareInfo } from '@/utils/wxShare'
const DxyView = {
  data() {
    return {
      dxyUrl: process.env.dxyUrl,
      domain: process.env.dxyDomain,
      iframeElement: null,
      iframeMessage: null,
    }
  },
  computed: {
  },
  mounted() {
    window.sessionStorage.setItem('mainId', '')
    window.sessionStorage.setItem('serviceId', '')
    getShareInfo({
      title: '房颤百问百答答案书',
      titleTimeLine: '房颤百问百答答案书',
      desc: '致力于打造房颤领域的"百问宝典"',
      link: window.location.href,
      linkTimeLine: window.location.href,
      images: `https://iep.jjmc.cn/bw/file/material/image/2030164722444406808.jpg`,
    })
    this.iframeElement = document.getElementById('dxyIframe')
    this.iframeMessage = new IframeMessenger({
      domain: this.domain,
      iframeElement: this.iframeElement,
      routeQuery: this.$route.query,
    })
    this.iframeMessage.init()
    // 监听消息
    this.IframeMessage.registerOnMessage(({action, data}, send) => {
    })
    // 等待iframe加载完成, 发送消息
    this.IframeElement.addEventListener('load', async () => {
    })
  },
  methods: {
  },
  beforeDestroy() {
    this.IframeMessage && this.IframeMessage.removeListener()
  },
}

export default withRouteTracking(DxyView)
</script>

<style scoped lang="less">
.dxy-view {
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dxy/index.vue